// components/qualificacao/useQualificar.js — marcar o lead e oferecer o
// "Desfazer" (out/26, rastreamento PR 2). Janela do contato e topo do chat
// usam o mesmo; a barra de lote usa só o `oferecer` (o lote vem da rota de
// lote).
//
// `onMudou(contatoId, qualificacao)` é como a tela de quem chamou se
// atualiza: a qualificação nova (ou null) vem pronta do servidor.

import { useCallback, useEffect, useRef, useState } from 'react';
import api from '../../services/Api';
import { DESFAZER_MS, descrever } from './regras';

const detalhe = (e, padrao) => e?.response?.data?.detail || padrao;

export default function useQualificar(onMudou) {
  // { registroId | lote, contatoId?, texto }
  const [desfazer, setDesfazer] = useState(null);
  const [erroDesfazer, setErroDesfazer] = useState('');
  const timer = useRef(null);
  // Desfazer em andamento: clique duplo mandava dois pedidos, e o 409 do
  // segundo trocava o sucesso por "Não deu para desfazer" (code-review).
  const desfazendo = useRef(false);
  const mudou = useRef(onMudou);
  mudou.current = onMudou;

  useEffect(() => () => clearTimeout(timer.current), []);

  const oferecer = useCallback((d) => {
    clearTimeout(timer.current);
    setErroDesfazer('');
    setDesfazer(d);
    timer.current = setTimeout(() => setDesfazer(null), DESFAZER_MS);
  }, []);

  const fechar = useCallback(() => {
    clearTimeout(timer.current);
    setDesfazer(null);
    setErroDesfazer('');
  }, []);

  const marcar = useCallback(async (contatoId, pedido) => {
    let data;
    try {
      ({ data } = await api.post(`/contacts/${contatoId}/qualificacao`, pedido));
    } catch (e) {
      throw new Error(detalhe(e, 'Não foi possível marcar. Tente de novo.'));
    }
    mudou.current?.(contatoId, data.qualificacao || null);
    if (data.mudou && data.registro_id) {
      oferecer({
        registroId: data.registro_id,
        contatoId,
        texto: data.qualificacao ? `Marcado como ${descrever(data.qualificacao)}.` : 'Marcação removida.',
      });
    }
    return data;
  }, [oferecer]);

  const desfazerAgora = useCallback(async () => {
    const d = desfazer;
    if (!d || desfazendo.current) return null;
    desfazendo.current = true;
    clearTimeout(timer.current);
    // Some o botão na hora.
    setDesfazer(null);
    try {
      const { data } = await api.post('/contacts/qualificacao/desfazer',
        d.lote ? { lote: d.lote } : { registro_id: d.registroId });
      if (d.contatoId) mudou.current?.(d.contatoId, data.qualificacao || null);
      return data;
    } catch (e) {
      setErroDesfazer(detalhe(e, 'Não foi possível desfazer.'));
      timer.current = setTimeout(fechar, DESFAZER_MS);
      return null;
    } finally {
      desfazendo.current = false;
    }
  }, [desfazer, fechar]);

  return { marcar, desfazer, erroDesfazer, oferecer, desfazerAgora, fecharDesfazer: fechar };
}
